export type DocsError<T extends string = string, D = unknown> = {
  code: T
  detail: D
}

export function createError<const T extends string, D>(
  code: T,
  detail: D,
): DocsError<T, D> {
  return {
    code,
    detail,
  }
}
